// extracted by mini-css-extract-plugin
export var carrierTab = "_3z-0";
export var carrierTabActive = "_3z-1 _3z-0";
export var carrierTabInactive = "_3z-2 _3z-0";
export var carrierTabLabel = "_3z-3";
export var carrierTabLabelActive = "_3z-4 _3z-3";
export var carrierTabLabelInactive = "_3z-5 _3z-3";
export var carrierTabPercentage = "_3z-6";
export var carrierTabPercentageActive = "_3z-7 _3z-6";
export var carrierTabPercentageInactive = "_3z-8 _3z-6";
export var carrierTabWinnable = "_3z-9";
export var carrierTabWinnableActive = "_3z-a _3z-9";
export var carrierTabWinnableInactive = "_3z-b _3z-9";
export var comparisonContainer = "_3z-d";
export var missingRateButton = "_3z-n";
export var missingRateButtonActive = "_3z-o _3z-n";
export var missingRateButtonInactive = "_3z-p _3z-n";
export var missingRateButtonLabel = "_3z-q";
export var missingRateButtonLabelActive = "_3z-r _3z-q";
export var missingRateButtonLabelInactive = "_3z-s _3z-q";
export var sidebar = "_3z-c";
export var strategyButton = "_3z-e";
export var strategyButtonActive = "_3z-f _3z-e";
export var strategyButtonDescription = "_3z-k";
export var strategyButtonDescriptionActive = "_3z-l _3z-k";
export var strategyButtonDescriptionInactive = "_3z-m _3z-k";
export var strategyButtonInactive = "_3z-g _3z-e";
export var strategyButtonLabel = "_3z-h";
export var strategyButtonLabelActive = "_3z-i _3z-h";
export var strategyButtonLabelInactive = "_3z-j _3z-h";
export var unitToggleButton = "_3z-t";
export var unitToggleButtonActive = "_3z-u _3z-t";
export var unitToggleButtonInactive = "_3z-v _3z-t";
export var unitToggleButtonLabel = "_3z-w";
export var unitToggleButtonLabelActive = "_3z-x _3z-w";
export var unitToggleButtonLabelInactive = "_3z-y _3z-w";